export default "__VITE_ASSET__VlGdyP2q__"